import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import { useScenario } from '../../../context/scenario/ScenarioContext';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ScenarioIndicator = () => {
  const { currentScenario } = useScenario();
  const location = useLocation();
  const { t } = useTranslation();
  const [scenarioName, setScenarioName] = useState('');
  const isExampleMode = location.state?.isExample;

  useEffect(() => {
    const fetchScenarioNameById = async (scenarioId) => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await fetch(`https://www.ia-schedule.com:4139/api/scenario/${scenarioId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const scenarioData = await response.json();
          setScenarioName(scenarioData.name);
        }
      } catch (error) {
        console.error('Error fetching scenario by ID:', error);
        setScenarioName(t('scenarios.unknown') || 'Unknown Scenario');
      }
    };

    if (isExampleMode) {
      setScenarioName(t('scenarios.example.name') || 'Example Scenario');
      return;
    }

    if (currentScenario?.name) {
      setScenarioName(currentScenario.name);
      return;
    }

    if (location.state?.scenarioName) {
      setScenarioName(location.state.scenarioName);
      return;
    }

    const storedScenario = sessionStorage.getItem('currentScenario');
    if (storedScenario) {
      try {
        const parsed = JSON.parse(storedScenario);
        if (parsed?.name) {
          setScenarioName(parsed.name);
          return;
        }
      } catch (error) {
        console.error('Error parsing stored scenario:', error);
      }
    }

    const storedScenarioId = sessionStorage.getItem('scenarioId');
    if (storedScenarioId) {
      try {
        const parsedData = JSON.parse(storedScenarioId);
        const scenarioId = parsedData?.scenarioId;

        if (scenarioId) {
          fetchScenarioNameById(scenarioId);
          return;
        }
      } catch (error) {
        console.error('Error parsing stored scenario ID:', error);
      }
    }

    setScenarioName(t('scenarios.unknown') || 'Unknown Scenario');
  }, [currentScenario, location.state, isExampleMode, t]);

  if (!scenarioName) return null;

  return (
    <div className="-mt-5 bg-gray-100 py-2 px-4 rounded-md flex items-center gap-2 text-sm text-gray-700 border-indigo-700 border shadow-sm">
      <FileText className="h-4 w-4 text-indigo-500" />
      <span>{t('scenarios.current')}: </span>
      <span className="font-medium">{scenarioName}</span>
    </div>
  );
};

export default ScenarioIndicator;